import React, { useEffect, useState } from "react"
import Image from "next/legacy/image"
import * as PropTypes from "prop-types"

const DEFAULT_FALLBACK = `/v1/car_model/not-found-image.png`

function ImageWithFallback(props) {
  const { src, priority, loading, fetchpriority, decoding, ...rest } = props
  const [imgSrc, setImgSrc] = useState(src || DEFAULT_FALLBACK)

  useEffect(() => {
    if (!src) {
      setImgSrc(DEFAULT_FALLBACK)
      return
    }
    setImgSrc(src)
  }, [src])

  return (
    <Image
      {...rest}
      src={imgSrc}
      priority={priority}
      loading={priority ? "eager" : loading || "lazy"}
      fetchpriority={priority ? "high" : fetchpriority || "low"}
      decoding={priority ? "sync" : decoding || "async"}
      onLoadingComplete={result => {
        if (result.naturalWidth === 0) {
          setImgSrc(DEFAULT_FALLBACK)
        }
      }}
      onError={() => setImgSrc(DEFAULT_FALLBACK)}
    />
  )
}

export default ImageWithFallback

ImageWithFallback.defaultProps = {
  height: null,
  width: null,
  alt: null,
  src: null,
  priority: false,
  loading: "lazy",
  fetchpriority: "low",
  decoding: "async"
}

ImageWithFallback.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  alt: PropTypes.string,
  src: PropTypes.string,
  priority: PropTypes.bool,
  loading: PropTypes.oneOf(["lazy", "eager"]),
  fetchpriority: PropTypes.oneOf(["high", "low", "auto"]),
  decoding: PropTypes.oneOf(["sync", "async", "auto"])
}
